import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8" data-id="element-22" data-mp="32o4deh7i4k9p">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-23" data-mp="32m1bozwzl2p5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-24" data-mp="36qhfmvn1i01q">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-25" data-mp="3ufjuxwu7bgt2">
            <img src="https://cdn.magicpatterns.com/uploads/dpR9DXwCEF7xE6YLwrKxu9/1-offical-logo.png" alt="Sinclair Development" className="h-20 w-auto border-2 border-white rounded-sm" data-id="element-26" data-mp="38qtqszerhoj" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-27" data-mp="3qc41189inuk2">
              Building the future with precision, integrity, and excellence.
              Sinclair Commercial Division is your trusted partner for premium
              construction and engineering solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-28" data-mp="3lbmvrwv0jgi0">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-29" data-mp="3gah1hulpfl6d">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-30" data-mp="3v7gbtq7xxs4j">
              {['Home', 'About', 'Certifications', 'Contact'].map(item => <li key={item} data-id="element-31" data-mp="3q7lnnufjvgn6">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-32" data-mp="3q7bxo6ui99hh">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-33" data-mp="ct78vlpj1vkb">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-34" data-mp="cus1h5sa74fj">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-35" data-mp="qu1gi24r3shx">
              <li className="text-gray-400 text-sm" data-id="element-36" data-mp="mrwplb5ot9yz">Commercial Construction</li>
              <li className="text-gray-400 text-sm" data-id="element-37" data-mp="mptptzeqg2h2">Mechanical Engineering</li>
              <li className="text-gray-400 text-sm" data-id="element-38" data-mp="two25of9174o">Electrical Systems</li>
              <li className="text-gray-400 text-sm" data-id="element-39" data-mp="yteeq1ruhklc">Project Management</li>
              <li className="text-gray-400 text-sm" data-id="element-40" data-mp="13tkclzopk3bv">Site Development</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-41" data-mp="18ksod2dig0s7">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-42" data-mp="18lkaznp4qo6c">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-43" data-mp="1cnozk80q0um4">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-44" data-mp="1hk5yzyddevei">
                <MapPin className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-45" data-mp="1hmibvx49ufkp" />
                <span data-id="element-46" data-mp="1mkjwwnl9coyt">
                  1234 Construction Blvd,
                  <br data-id="element-47" data-mp="1rj4zgtnzfkqf" />
                  Fort Myers, FL 33901
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-48" data-mp="3oc6s71c6n613">
                <Phone className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-49" data-mp="3t9q4vwt8faqx" />
                <a href="tel:239-810-9482" className="hover:text-white transition-colors" data-id="element-50" data-mp="3tc2wl1oskzh6">
                  239-810-9482
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-51" data-mp="21mths6ob0u1b">
                <Mail className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-52" data-mp="21kpf1s25612m" />
                <a href="mailto:info@sinclaircommercial.com" className="hover:text-white transition-colors" data-id="element-53" data-mp="1wp0atbf6fvzz">
                  info@sinclaircommercial.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-54" data-mp="2kbgk4hf3j5b7">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-55" data-mp="2fgkrbf21cdx1">
            © {new Date().getFullYear()} Sinclair Development. All rights
            reserved.
            <span className="mx-2 text-white/20" data-id="element-56" data-mp="13xgmxe7mxtrn">|</span>
            <span className="text-[#C5A55A] tracking-wider" data-id="element-57" data-mp="2rvzib1bupjnw">
              FL License #CGC1541661
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-58" data-mp="2wn99i6d1sv1w">
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-59" data-mp="2iv1h0qssrq90">
              <Facebook className="w-4 h-4" data-id="element-60" data-mp="2ntcs14utw6st" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-61" data-mp="2nrrxvgcfepvh">
              <Twitter className="w-4 h-4" data-id="element-62" data-mp="3fllj1t7vg6y0" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-63" data-mp="3fize81cd85jh">
              <Linkedin className="w-4 h-4" data-id="element-64" data-mp="36k44ifa44dbf" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-65" data-mp="36mqaiahcukrj">
              <Instagram className="w-4 h-4" data-id="element-66" data-mp="1v601kjljreu8" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}